<template>
  <div
    class="app-icon-arrow"
    :class="{ 'is-focus': isFocus }"
  >
    <img
      v-if="isDisable"
      src="@/assets/icon/icon_select_arrow_gray.svg"
      alt=""
      class="app-icon-arrow__image"
    >
    <img
      v-else
      src="@/assets/icon/icon_select_arrow_black.svg"
      alt=""
      class="app-icon-arrow__image"
    >
  </div>
</template>

<script>
export default {
  props: {
    isFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-icon-arrow {
  height: .75rem;
  pointer-events: none;
  position: absolute;
  right: .5rem;
  top: calc(50% - .375rem);
  transition: transform .2s;
  width: .75rem;

  &.is-focus {
    transform: rotateZ(180deg);
  }

  &__image {
    display: block;
    width: 100%;
  }
}
</style>